import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
	selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {

	constructor(private el: ElementRef) {
	}

	@Input('appOnlyNumber') public OnlyNumber: boolean;

	@HostListener('keydown', ['$event']) onKeyDown(event) {
		const e = <KeyboardEvent> event;
		if (this.OnlyNumber) {
			if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
				// Allow: Ctrl+A
				(e.keyCode === 65 && e.ctrlKey === true) ||
				// Allow: Ctrl+C
				(e.keyCode === 67 && e.ctrlKey === true) ||
				// Allow: Ctrl+V
				(e.keyCode === 86 && e.ctrlKey === true) ||
				// Allow: Ctrl+X
				(e.keyCode === 88 && e.ctrlKey === true) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 40)) {
				// let it happen, don't do anything
				return;
			}
			// Ensure that it is a number and stop the keypress
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		}
	}

	@HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
		if (this.OnlyNumber) {
			event.preventDefault();
			const pastedText = event.clipboardData?.getData('text/plain');
			if (pastedText) {
				// Filter out non-numeric characters
				const filteredText = pastedText.replace(/[^0-9]/g, '');
				document.execCommand('insertText', false, filteredText);
			}
		}
	}
}
